import { render, staticRenderFns } from "./android.vue?vue&type=template&id=4e225a01&scoped=true&"
import script from "./android.vue?vue&type=script&lang=js&"
export * from "./android.vue?vue&type=script&lang=js&"
import style0 from "./android.vue?vue&type=style&index=0&id=4e225a01&lang=less&scoped=true&"
import style1 from "./android.vue?vue&type=style&index=1&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e225a01",
  null
  
)

export default component.exports